import React, { Component } from 'react';
import { FLICKER_DETAIL_IMAGES_API_URL } from '../../../store/constants/urls';
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';
import './galleryDetail.css';
import { scrollTop } from '../../../utils/helpers';

class GalleryDetail extends Component {

    state = {
        comments: [],
        photos: [],
        title: "",
    }

    componentDidMount = () => {
        scrollTop();
        const id = this.props.match.params.id;
        const url = `${FLICKER_DETAIL_IMAGES_API_URL}&&photoset_id=${id}`
        let self = this;
        fetch(url)
            .then(res => res.json())
            .then(data => {
                if (data.photoset) {
                    let { photo: photos, title } = data.photoset;

                    self.setState({
                        photos,
                        title,
                    })

                }
            })
    };

    galleryItems = () => {
        let { photos } = this.state;
        return photos && photos.map(d => ({
            original: d.url_m,
            thumbnail: d.url_t,
            originalAlt: d.title,
            thumbnailAlt: d.title,
            description: d.title,
        })
        )
    }

    render() {

        let { title } = this.state;

        return (
            <section id="gallery-detail">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="inner-title change-title">
                                <h1>
                                    Gallery
                                </h1>
                                {/* <div className="pull-right">
                                    <div className="btn-group">
                                        <button type="button" className="btn" onClick={() => this.handlePage("Prev")} > {` << Prev`}</button>
                                        <span className="btn">{`${1} of ${10}`}</span>
                                        <button type="button" className="btn" onClick={() => this.handlePage("Next")}> {`Next >> `}</button>
                                    </div>
                                </div> */}
                            </div>
                            <div className="detail-carousel">
                                <div className="gallery-detail-title">
                                    <h5>{title}</h5>
                                </div>
                                <div className="clearfix"></div>
                                <ImageGallery
                                    items={this.galleryItems()}
                                    showPlayButton={false}
                                    showIndex={true}
                                    autoPlay={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default GalleryDetail
